import { axiosRequest } from "../axios.config";

const subscriptionAPI = {
  subscribe: async (params) => {
    const instructorId = params;
    const url = "Subscription";
    const response = await axiosRequest.post(url, null, {
      params: { instructorId },
    });
    return response;
  },
  unsubscribe: async (params) => {
    const SubscriberId = params;
    const url = "Subscription";
    const response = await axiosRequest.delete(url, {
      params: { SubscriberId },
    });
    return response;
  },
  getAllSubscription: async () => {
    const url = "Subscription/Get-All-Subscription";
    const response = await axiosRequest.get(url);
    return response;
  },
  getAllSubscriber: async (params) => {
    const url = "Subscription/Get-All-Subscriber";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  getTotalSubscriber: async (params) => {
    const userId = params;
    const url = "Subscription/Get-total-subscriber";
    const response = await axiosRequest.get(url, { params: { userId } });
    return response;
  },
  getTotalSubscription: async () => {
    const url = "Subscription/Get-total-subscription";
    const response = await axiosRequest.get(url);
    return response;
  },
  isSubscribed: async (params) => {
    const instructorId = params;
    const url = "Subscription/Is-Subscription";
    const response = await axiosRequest.get(url, { params: { instructorId } });
    return response;
  },
};

export { subscriptionAPI };
